import styled from 'styled-components';

export const ListMyCourses = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: start;
  padding: 1rem;
  gap: 2rem;
  height: auto;
  overflow: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const ContainerTable = styled.div`
  margin: auto;
  width: 98%;
`;

export const togleStyle = { display: 'flex', justifyContent: 'flex-end' };
export const dropdownStyle = { display: 'flex', justifyContent: 'flex-end' };

export default {
  ListMyCourses,
  togleStyle,
  dropdownStyle,
  ContainerTable,
};
